import { render, staticRenderFns } from "./HeadlineAuthor.vue?vue&type=template&id=2393c4cb&"
import script from "./HeadlineAuthor.vue?vue&type=script&lang=ts&"
export * from "./HeadlineAuthor.vue?vue&type=script&lang=ts&"
import style0 from "./HeadlineAuthor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports